module.exports = __webpack_public_path__ + "static/media/comment-icon.2de51354.svg";